import { render } from "./view-form.vue?vue&type=template&id=65de48fd&lang=html"
import script from "./view-form.vue?vue&type=script&lang=js"
export * from "./view-form.vue?vue&type=script&lang=js"

import "./view-form.vue?vue&type=style&index=0&id=65de48fd&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__